// ---------------------------------------------------------------------------
// Azure Active Directory / MSAL configuration
// Replace the placeholder values below with your Azure AD App Registration details.
// You can find these in the Azure Portal → Azure Active Directory → App Registrations
// ---------------------------------------------------------------------------

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    // localStorage, not sessionStorage: session storage belongs to one tab,
    // and a link opened in a new tab with noopener (or a plain target=_blank)
    // starts with it empty -- so the new tab asked people to sign in again.
    // Local storage is shared by every tab of the site.
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};
